import { Component, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { Filter } from '../../models/filter';
import { ProfessionService } from '../../services/profession.service';
import { IProfession } from '../../interfaces/profession/iprofession';

@Component({
  selector: 'split-filter-profession',
  templateUrl: './split-filter-profession.component.html',
  styleUrls: ['./split-filter-profession.component.scss']
})
export class SplitFilterProfessionComponent {
  public data: IFilterData[] = [];

  @Input() field!: string;
  @Input() label!: string;
  @Input() key!: string;
  @Input() groupId!: string;

  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  private filter = new Filter();

  constructor(private professionService: ProfessionService) {

  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    let filter = this.filter.convertFilterInQuery();
    this.professionService.getAll(filter).pipe(
      map((professions: IProfession[]) => professions.map(profession => ({ name: profession.name, id: profession.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        this.data = data;
      }
    )
  }

  onSearchDropdownChange($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.load();
  }

}
